import { array, number, object, string } from 'yup';

import { arrayUniqueBy } from '../../shared/functions/array-unique-by';
import { IDynamicComponentConfig } from '../types/dynamic-component-config.interface';
import { IPageDefinition } from '../types/page-definition.interface';

export const pageDefinitionSchema = object<IPageDefinition>({
  name: string().required(),
  slug: string().required(),
  layoutDefinition: array<IDynamicComponentConfig>().required().min(1),
  sortWeight: number().optional().min(0).integer(),
}).required();

export const pageDefinitionsSchema = array<IPageDefinition>()
  .required()
  .test({ name: 'name', message: 'name is not unique', test: arrayUniqueBy('name') })
  .test({ name: 'slug', message: 'slug is not unique', test: arrayUniqueBy('slug') })
  .of(pageDefinitionSchema);
